module.exports = __webpack_public_path__ + "img/volkl.e3424380.png";